import * as Immutable from "immutable";

import { ContactMatchingPhoneNumberResult } from "@/Common/Api/CallCenter/Responses/ContactMatchingPhoneNumberResult";
import { CallIdAndNumber } from "./CallIdAndNumber";

class CallMatches {
    private readonly callIdAndNumber: CallIdAndNumber;
    private readonly matches: Immutable.List<ContactMatchingPhoneNumberResult> | null;

    constructor(callIdAndNumber: CallIdAndNumber, matches: Immutable.List<ContactMatchingPhoneNumberResult> | null) {
        Object.assign(this, { callIdAndNumber, matches });
    }

    public get CallIdAndNumber(): CallIdAndNumber {
        return this.callIdAndNumber;
    }

    public get Matches(): Immutable.List<ContactMatchingPhoneNumberResult> | null {
        return this.matches;
    }

    public get HasLoadedMatches(): boolean {
        return this.matches !== null;
    }

    public WithMatches(matches: Immutable.List<ContactMatchingPhoneNumberResult>): CallMatches {
        return new CallMatches(this.callIdAndNumber, matches);
    }
}

export { CallMatches };
